import React from 'react';
import { Download, Settings, Zap } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="py-20 lg:py-32 bg-white text-navy-dark" data-id="element-63">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-66">
            Cómo funciona
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-67">
            Tres pasos simples para pasar de la vulnerabilidad total a tener un
            escudo financiero automático.
          </p>
        </div>

        <div className="relative" data-id="element-68">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-cream-dark -translate-y-1/2 z-0" data-id="element-69"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 relative z-10" data-id="element-70">
            {/* Step 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border border-cream text-center relative" data-id="element-71">
              <div className="w-16 h-16 bg-navy text-gold rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-72">
                1
              </div>
              <Download className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-73" />
              <h3 className="font-bold text-xl text-navy mb-3" data-id="element-74">
                Descarga y Escanea
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-75">
                Descarga el manual y aplica el Escaneo de Activos para obtener
                liquidez hoy mismo, sin pedir prestado.
              </p>
            </div>

            {/* Step 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border border-cream text-center relative" data-id="element-76">
              <div className="w-16 h-16 bg-navy text-gold rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-77">
                2
              </div>
              <Settings className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-78" />
              <h3 className="font-bold text-xl text-navy mb-3" data-id="element-79">
                Configura las Capas
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-80">
                Configura tus 3 capas de seguridad bancaria siguiendo el
                Protocolo 3-2-1. Toma exactamente 15 minutos.
              </p>
            </div>

            {/* Step 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border border-cream text-center relative" data-id="element-81">
              <div className="w-16 h-16 bg-gold text-navy rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-82">
                3
              </div>
              <Zap className="w-8 h-8 text-navy mx-auto mb-4" data-id="element-83" />
              <h3 className="font-bold text-xl text-navy mb-3" data-id="element-84">
                Ejecuta y Olvida
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-85">
                Ejecuta las transferencias automáticas y mira cómo tu Arca se
                llena sola mientras duermes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}